import { AREAS } from "../data/calendar";

// Período da área: o do simulado no backend; sem ele, o do calendário.
export const areaWindow = (area, periods) => (periods && periods[area.slug]) || area;

// Início do primeiro simulado a entrar no ar (alimenta o countdown).
export const firstOpenAt = (periods) =>
  AREAS.map((a) => areaWindow(a, periods).opensAt).reduce((min, d) => (new Date(d) < new Date(min) ? d : min));

// Status de um simulado: locked | live | done | expired.
// Sem login o sistema não sabe quem é o aluno, então nunca há "done".
export const getStatus = (area, now, progress, logged, periods) => {
  const p = progress && progress[area.slug];
  const { opensAt, closesAt } = areaWindow(area, periods);
  if (logged && p && p.submittedAt) return "done";
  if (now < new Date(opensAt).getTime()) return "locked";
  if (now > new Date(closesAt).getTime()) return "expired";
  return "live";
};

export const answeredCount = (progress, slug) => {
  const p = progress && progress[slug];
  return p ? Object.keys(p.answers || {}).length : 0;
};

// Só aceita caminhos internos para o ?next= do login.
export const safeNext = (next, fallback = "/simulados") =>
  next && next.startsWith("/") && !next.startsWith("//") ? next : fallback;
